import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Moon, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy-900 text-cream-50 pt-16 pb-24 md:pt-24 md:pb-32 overflow-hidden" data-id="element-154">
      {/* Subtle background elements */}
      <div className="absolute top-10 right-10 opacity-10" data-id="element-155">
        <Moon size={120} strokeWidth={1} data-id="element-156" />
      </div>
      <div className="absolute top-20 left-20 opacity-20" data-id="element-157">
        <Star size={24} strokeWidth={1.5} data-id="element-158" />
      </div>
      <div className="absolute top-40 right-1/4 opacity-10" data-id="element-159">
        <Star size={16} strokeWidth={1.5} data-id="element-160" />
      </div>
      <div className="absolute bottom-20 left-1/3 opacity-10" data-id="element-161">
        
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-navy-950/50 to-transparent pointer-events-none" data-id="element-162" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-163">
        <div className="max-w-4xl mx-auto text-center" data-id="element-164">
          <FadeIn data-id="element-165">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6 text-white" data-id="element-166">
              Protocolo Próstata: Noches en Paz — El Método de 72 Horas para
              Recuperar tu Sueño y Tu Libertad
            </h1>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-167">
            <h2 className="text-xl md:text-2xl text-cream-100/90 font-body leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-168">
              Deja de levantarte 3 veces por noche y vuelve a dormir 7 horas
              seguidas sin medicamentos costosos ni cirugías invasivas.
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-169">
            <div className="mb-12 flex justify-center" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/eVPGx4bf25Dj1a1Lq4KT22/image_(2).png" alt="Hombre leyendo el Protocolo Próstata: Noches en Paz en su tablet por la noche" className="w-full max-w-[500px] rounded-2xl shadow-2xl shadow-black/60 border-2 border-gold-500/40 object-cover" data-id="element-171" />
            </div>
          </FadeIn>

          <FadeIn delay={0.3} className="flex justify-center" data-id="element-172">
            <Button className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-173">
              ¡QUIERO DORMIR TODA LA NOCHE!
            </Button>
          </FadeIn>
        </div>
      </div>
    </section>;
}